import {OrderModel} from "../order.model";
import {OrderModelAll} from "../../shared/models/order.model";

export class ChatInputDataModel {
  order: OrderModel | OrderModelAll;
  chatRoomGroupChannelUrl: string;
  chatRoomUserId: string;
  visible: boolean;
}
